import React, { useMemo } from 'react';

import { ConfigContext } from './config-context';
import { useCreateConfigContext } from './hooks/use-create-config-context.hook';

export type ConfigContextProps = {
  children: React.ReactNode;
  renderError: (error: unknown) => React.ReactNode;
  renderLoading: () => React.ReactNode;
};

export const ConfigContextProvider = ({
  children,
  renderError,
  renderLoading,
}: ConfigContextProps) => {
  const config = useCreateConfigContext();
  const value = useMemo(() => config, [config]);

  if (config.error) {
    return renderError(config.error);
  }

  if (!config.loaded) {
    return renderLoading();
  }

  return <ConfigContext.Provider value={value}>{children}</ConfigContext.Provider>;
};
